import React from 'react';

import cn from 'classnames';

interface IProps {
  center?: boolean;
  className?: string;
  textAlign?: string;
  centerVertical?: boolean;
  spaceBetween?: boolean;
  centerHorizontal?: boolean;
  flex?: boolean;
  flexColumn?: boolean;
  children?: JSX.Element;
  disabled?: boolean;
}

const Box = ({
  center,
  flex,
  centerVertical,
  centerHorizontal,
  spaceBetween,
  flexColumn,
  textAlign,
  className,
  ...props
}: IProps) => {
  const isTextRight = textAlign === 'right';

  const boxClassNames = cn(className, {
    // textAlign only controls text alignment, not layout
    flex:
      center ||
      centerVertical ||
      centerHorizontal ||
      flex ||
      flexColumn ||
      spaceBetween,
    'items-center': center || centerVertical,
    'justify-center': center || centerHorizontal,
    'justify-between': spaceBetween,
    'flex-col': flexColumn,
    'text-center': textAlign === 'center',
    'text-left': textAlign === 'left',
    'text-right': isTextRight,
  });

  return <div className={boxClassNames} {...props} />;
};

export default Box;
